import { States, zodRecordWithEnum } from '@eigtech/function-utils';
import { z } from 'zod';
export const GlobalRatesSchema = z.object({
    stateTax: zodRecordWithEnum(States.UsStatesAbbreviatedSchema, z.number().min(0).max(1)),
});
